import React from "react";
import SchoolLeaderSignupModal from "./SchoolLeaderSignupModal";
import { useStartExperiment } from "@src/utils/experiment";
import { ExternalSwitches } from "@src/utils/experiments/constants";
import { useFeatureFlag } from "@src/utils/useFeatureFlag";
import SignupCombinedModal from "@src/components/modals/SignupCombinedModal";

const SchoolLeaderSignupModalContainer = (props: { closeModal: () => void }) => {
  useStartExperiment(ExternalSwitches.WEB_EXTERNAL_LOGIN_SIGNUP_SL);
  const showCombinedModal = useFeatureFlag(ExternalSwitches.WEB_EXTERNAL_LOGIN_SIGNUP_SL).actualValue === "test";
  return showCombinedModal ? <SignupCombinedModal {...props} schoolLeader /> : <SchoolLeaderSignupModal {...props} />;
};

export default SchoolLeaderSignupModalContainer;
